import { render } from 'preact'

const PinterestButton = ({
  description,
  imgSrc,
  url,
}) => {
  const onClick = (e) => {
    const endpoint = `https://www.pinterest.com/pin/create/link/?description=${description}&media=${imgSrc}&url=${url}&autologin=true`
    const w = window.innerWidth
    const h = window.innerHeight
    window.open(endpoint, '_blank', `height=750,width=750,top=${(h - 750) / 2},left=${(w - 750) / 2},scrollsbars=no,menubar=no,location=no,titlebar=no,`)
    e.stopPropagation()
  }
  return (
    <button onClick={onClick} className="mv-create-pin-button">
      <span class="screen-reader-text">Create Pinterest Pin</span>
      <i className="mv-icon-pinterest" />
    </button>
  )
}

export default els => Array.prototype.forEach.call(els, (el) => {
  // Don't display Pinterest on IE11 (and any other browsers that don't support object-fit)
  if ('objectFit' in document.documentElement.style === false) {
    return
  }

  if (el.hasAttribute('data-mvloaded')) {
    return
  }
  el.setAttribute('data-mvloaded', true)
  render(
    (
      <PinterestButton
        description={el.getAttribute('data-mv-pinterest-desc')}
        url={el.getAttribute('data-mv-pinterest-url')}
        imgSrc={el.getAttribute('data-mv-pinterest-img-src')}
      />
    ), el,
  )
})
